import { FormControl, ValidatorFn, FormGroup, ValidationErrors, FormArray, Form, Validators } from '@angular/forms';
import * as luxon from 'luxon';
import { Store } from '@ngrx/store';
import { AppState } from "../../projects/brokerage-eapp/src/app/app-reducer";
import construct = Reflect.construct;
import { forEach } from "@angular-devkit/schematics";
import { distinctUntilChanged, map, startWith } from "rxjs/operators";
import { NGB_DATEPICKER_18N_FACTORY } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n';

const monthYearFormat = 'MM/dd/yyyy';
const yearMonthFormat = 'yyyy-MM-dd';
const beginDate = '1000-01-01';
const letterTwelveNumbers = '1 Alpha + 12 Numeric';
const letterEightNumbers = '1 Alpha + 8 Numeric';
const letterNineNumbers = '1 Alpha + 9 Numeric';
const eightNumbers = '7-8 Numeric';
isvalidatePastDate:Boolean;
let isvalidatePastDate=false;
// block ineligible state field entries
export function validateStateEligible(control: FormControl) {
  if (control.value === 'NY') {
    return { invalidState: true };
  }
}

// validate name
export function validateName(control: FormControl) {
  // const REGEX = /^[a-z0-9\s\-\.]+$/i;
 const REGEX = /^[a-z\s\-\']+$/gi;
  const REGEX2 = /^(?!^ +$)^.+$/gi;

  if (!control.value || (control.value.match(REGEX) && control.value.match(REGEX2))) {
    return null;
  } else {
    return { invalidName: true };
  }
}

// validate name
export function validateZip(control: FormControl) {
  // const REGEX = /^[a-z0-9\s\-\.]+$/i;
  const REGEX = /^(?!0{5})\d{5}$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidZip: true };
  }
}

// validate name
export function validateAddress1(control: FormControl) {
  // const REGEX = /^[a-z0-9\s\-\.]+$/i;
  const REGEX = /^(?!^ +$)^.+$/gi;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidAddress1: true };
  }
}

// validate no all space field
export function validateNoAllSpace(control: FormControl) {
  const REGEX = /^(?!^ +$)^.+$/gi;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidAddress1: true };
  }
}

// valid phone number
export function validatePhone(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check for valid model
  if ((control.value.length === 12)) {
    return null;
  } else {
    return { invalidPhone: true };
  }
}

export function multipleCheckboxRequired(minRequired = 1): ValidatorFn {
  return function validate(formGroup: FormGroup) {
    let checked = 0;

    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];

      if (control.value === true) {
        checked++;
      }
    });

    if (checked < minRequired) {
      return {
        minOneSelection: true,
      };
    }

    return null;
  };
}

// valid email address
export function validateEmail(control: FormControl) {
  const REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidEmail: true };
  }
}

// validate social security
export function validateSS(control: FormControl) {
  const known_fakes = ['078-05-1120', '219-09-9999'];

  if (!control.value) {
    return null;
  }

  // implement known SS # rules
  if (control.value.length === 11) {
    return null;
  } else {
    return { invalidSS: true };
  }
}

// validate tax id
export function validateTaxId(control: FormControl) {
  if (!control.value) {
    return null;
  }

  // implement known Tax ID # rules
  if (control.value.length === 10) {
    return null;
  } else {
    return { invalidTID: true };
  }
}

function isAfter(date: luxon.DateTime, date2: luxon.DateTime = null): boolean  {
  
  if (!date2) {
    const strPassedDate = luxon.DateTime.now().toFormat(monthYearFormat);
    date2 = luxon.DateTime.fromFormat(strPassedDate, monthYearFormat);
  } else {
    const strPassedDate = date2.toFormat(monthYearFormat);
    date2 = luxon.DateTime.fromFormat(strPassedDate, monthYearFormat);
  }
  const strDate = date.toFormat(monthYearFormat);
  date = luxon.DateTime.fromFormat(strDate, monthYearFormat);
  return date > date2;
}

function isBefore(date: luxon.DateTime, date2: luxon.DateTime = null): boolean  {
  if (!date2) {
    const strPassedDate = luxon.DateTime.now().toFormat(monthYearFormat);
    date2 = luxon.DateTime.fromFormat(strPassedDate, monthYearFormat);
  } else {
    const strPassedDate = date2.toFormat(monthYearFormat);
    date2 = luxon.DateTime.fromFormat(strPassedDate, monthYearFormat);
  }
  const strDate = date.toFormat(monthYearFormat);
  date = luxon.DateTime.fromFormat(strDate, monthYearFormat);
  return date2 > date;
}

// validate date full mm/dd/yyyy
export function validateDate(control: FormControl) {
 
  // empty models are valid
  if (!control.value) {
    return null;
  }
  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }

  const date = luxon.DateTime.fromFormat(control.value, monthYearFormat);
  const validDate = luxon.DateTime.fromFormat(beginDate, yearMonthFormat);
  const isFuture = isAfter(date);
  const isValid = isAfter(date, validDate);
 
  if ((isFuture || !isValid ) && isvalidatePastDate==false) {
    return { invalidDate: true };
  } else {
    isvalidatePastDate=false;
    return null;
  }
}

// validate date full mm/dd/yyyy
export function validateFutureDate(control: FormControl) {
  
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const date = luxon.DateTime.fromFormat(control.value, monthYearFormat);
  const validDate = luxon.DateTime.fromFormat(beginDate, yearMonthFormat);
  const isFuture = isAfter(date);
  const isValid = isAfter(date, validDate);
 
  if (!isFuture || !isValid) {
    return { invalidDate: true };
  } else {
    return null;
  }
}

function isBadFormat(dt: luxon.DateTime) {
  if (!dt.invalidReason) {
    return false;
  } else {
    return true;
  }
}

// validate date short mm/yyyy
export function validateDateShort(control: FormControl) {
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 7) {
    return { invalidDate: true };
  }

  const date = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  if (isBadFormat(date)) {
    return { invalidDate: true };
  }
  const validDate = luxon.DateTime.fromFormat(beginDate, yearMonthFormat);
  const isFuture = isAfter(date);
  const isValid = isAfter(date, validDate);

  if (isFuture || !isValid) {
    return { invalidDate: true };
  } else {
    return null;
  }
}


// validate date short mm/yyyy
export function validateDateShortFuture(control: FormControl) {
  if (!control.value) {
    return null;
  }
  // check length
  if (control.value && control.value.length !== 7) {
    return { invalidDate: true };
  }
  
  const datePlusOneMonth = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').plus({ months: 1 });
  if (isBadFormat(datePlusOneMonth)) {
    return { invalidDate: true };
  }
  const dateNow = luxon.DateTime.now();
  const dateCtrlMinusOne = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').minus({ months: 1 });

  const isPast = isBefore(datePlusOneMonth);
  const yearsFromNow = Math.floor(dateCtrlMinusOne.diff(dateNow, 'years').years);
 

  if (isPast) {
    return { invalidDate: true };
  } else if (yearsFromNow >= 2) {
    return { invalidDateRange: true };
  } else {
    return null;
  }
}

// validate date full mm/dd/yyyy
export function validate2YrsFutureDate(control: FormControl) {
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const dateNow = luxon.DateTime.now();
  const date = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const isPast = isBefore(date);

  const yearsFromNow = Math.floor(date.diff(dateNow, 'years').years);

  if (isPast || !date.isValid) {
    return { invalidDate: true };
  } else if (yearsFromNow >= 2) {
    return { invalidDateRange: true };
  } else {
    return null;
  }
}

// validate date full mm/dd/yyyy
export function validate1YrFutureDate(control: FormControl) {
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const dateNow = luxon.DateTime.now();
  const date = luxon.DateTime.fromFormat(control.value, 'MM/dd/yyyy');
  const isPast = isBefore(date);

  const yearsFromNow = date.diff(dateNow, 'years').years;

  if (isPast || !date.isValid) {
    return { invalidDate: true };
  } else if (yearsFromNow > 1) {
    return { invalidDateRange: true };
  } else {
    return null;
  }
}

// validate date full mm/dd/yyyy
export function validate10YrsPastDate(control: FormControl) {
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const dateCtrlMinusOne = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').minus({ months: 1 });
  const isFuture = isAfter(dateCtrlMinusOne);
  const yearsAgo = Math.floor(dateNow.diff(dateCtrlVal, 'years').years);

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo > 10) {
    return { invalidDateRange: true };
  } else {
    return null;
  }
}

// validate date short mm/yyyy
export function validate5YrsPastDateShort(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 7) {
    return { invalidDate: true };
  }

  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const datePlusOneMonth = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').plus({ months: 1 });
  const isFuture = isAfter(dateCtrlVal);
  const yearsAgo = Math.floor(dateNow.diff(datePlusOneMonth, 'years').years);

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo >= 5) {
    return { invalidDateRage: true };
  } else {
    return null;
  }
}

// validate date full mm/dd/yyyy
export function validate5YrsPastDateLong(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }

  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const isFuture = isAfter(dateCtrlVal);
  const yearsAgo = dateNow.diff(dateCtrlVal, 'years').years;

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo >= 5) {
    return { invalidDateRage: true };
  } else {
    return null;
  }
}

// validate date short mm/yyyy
export function validate3YrsPastDateShort(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 7) {
    return { invalidDate: true };
  }

  
  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const datePlusOneMonth = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').plus({ months: 1 });

  const isFuture = isAfter(dateCtrlVal);
  const yearsAgo = Math.floor(dateNow.diff(datePlusOneMonth, 'years').years);

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo >= 3) {
    return { invalidDateRage: true };
  } else {
    return null;
  }
}

// validate date long mm/yyyy
export function validate1YrPastDate(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }

  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const isFuture = isAfter(dateCtrlVal);
  const yearsAgo = Math.floor(dateNow.diff(dateCtrlVal, 'years').years);

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo >= 1) {
    return { invalidDateRage: true };
  } else {
    return null;
  }
}


// validate date short mm/yyyy 1 yr past date
export function validate1YrShortPastDate(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 7) {
    return { invalidDate: true };
  }

  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const datePlusOneMonth = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').plus({ months: 1 });
  const isFuture = isAfter(dateCtrlVal);
  const yearsAgo = Math.floor(dateNow.diff(datePlusOneMonth, 'years').years);

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo >= 1) {
    return { invalidDateRage: true };
  } else {
    return null;
  }
}



// validate date short mm/yyyy
export function validate2YrsPastDate(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 7) {
    return { invalidDate: true };
  }

  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const datePlusOneMonth = luxon.DateTime.fromFormat(control.value, 'MM/yyyy').plus({ months: 1 });
  const isFuture = isAfter(dateCtrlVal);
  const yearsAgo = Math.floor(dateNow.diff(datePlusOneMonth, 'years').years);

  if (isFuture) {
    return { invalidDate: true };
  } else if (yearsAgo >= 2) {
    return { invalidDateRage: true };
  } else {
    return null;
  }
}

// validate AGE
export function validateAge(control: FormControl): any {
  if (!control.value) { return null; }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, monthYearFormat);
  const age = Math.floor(dateNow.diff(dateCtrlVal, 'years').years);

  const isOver79 = Math.round(age) > 79;
  const isUnder18 = Math.round(age) < 18;

  if (isOver79 || isUnder18) {
    return { invalidAge: true };
  } else {
    return null;
  }
}

// validate min AGE for owners
export function validateMinAge(control: FormControl): any {
  if (!control.value) { return null; }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const dateNow = luxon.DateTime.now();
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, monthYearFormat);
  const age = Math.floor(dateNow.diff(dateCtrlVal, 'years').years);

  const isUnder20 = Math.round(age) < 20;

  if (isUnder20) {
    return { invalidMinAge: true };
  } else {
    return null;
  }
}

export function validateNumber(control: FormControl): any {
  if (!control.value) {
    return null;
  } else if (control.value.match(/^[0-9]*$/i)) {
    return null;
  } else {
    return { invalidNumber: true };
  }
}

// weight loss should be more than 10lbs
export function validateWeightAmount(control: FormControl) {
  if (control.value && (Number(control.value) < 10)) {
    return { invalidWeightAmount: true };
  }

  if (control.value) {
    const REGEX = /^\d{1,3}$/;

    if (!(control.value).match(REGEX)) {
      return { invalidThreeDigit: true };
    }
  }

  return null;

}

// height inches 0 to 11 only
export function validateHeightInches(control: FormControl): any {
  const REGEX = /^([0-9]|1[01])$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidInches: true };
  }
}

// height: 3 to 8 (feet) only
export function validateHeightFeet(control: FormControl): any {
  const max = 8;
  const min = 3;
  const REGEX = /^([1-9])$/i;

  if (!control.value || (control.value.toString().match(REGEX) && control.value >= min && control.value <= max)) {
    return null;
  } else {
    return { invalidFeet: true };
  }
}

// weight max: 500(lbs)
export function validateWeight(control: FormControl): any {
  const max = 500;
  const min = 50;

  if (!control.value || (control.value <= max && control.value >= min)) {
    return null;
  } else {
    return { invalidWeight: true };
  }
}

// percentage: 0 to 100(%)
export function validatePercentage(control: FormControl): any {

  const REGEX = /^(100|[0-9][0-9]?)$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidPercentage: true };
  }
}

// percentage: 1 to 100(%)
export function validatePercentageNoZero(control: FormControl): any {

  const REGEX = /^[1-9][0-9]?$|^100$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidPercentage: true };
  }
}

// percentage: 100(%)
export function validatePercentageAllocation(control: FormControl): any {
  if (!control.value && control.value!=0 || control.value === 100) {
    return null;
  } else {
    return { invalidPercentage: true };
  }
}

export function validateOwnerAmount(control: FormControl): any {
  if (!control.value || control.value === 100) {
    return null;
  } else {
    return { invalidPercentage: true };
  }
}

export const primaryCarePhysicianValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const primaryCarePhysician = control.get('PrimaryCarePhysician');
  const primaryPhysician = control.get('PrimaryPhysician');
  const dateofLastVisit = control.get('DateofLastVisit');
  const reasonforLastVisit = control.get('ReasonforLastVisit');

  return primaryCarePhysician.value ? { invalidPrimaryCarePhysician: true } : null;
};

// credit card validation
export function validateCreditCardFormat(control: FormControl) {
  const REGEX = /^(2|4|5|6)\d*$/;

  // empty models are valid
  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidCreditCardFormat: true };
  }
}

// credit card date validation
export function validateDateIsPast(control: FormControl) {
  // empty models are valid
  if (!control.value) {
    return null;
  }

  if (control.value.length === 7) {
    
  const dateCtrlVal = luxon.DateTime.fromFormat(control.value, 'MM/yyyy');
  const isFuture = isAfter(dateCtrlVal);

    return isFuture ? null : { invalidCreditCardDate: true };
  } else {
    return null;
  }
}

// credit card CVV validation
export function validateCVV(control: FormControl) {
  const REGEX = /^\d+$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidCVV: true };
  }
}

// validate account number
export function validateBankAccountNumber(control: FormControl) {
  const REGEX = /^\d+$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidBankAccountNumber: true };
  }
}

// validate account number
export function validateBankAccountNumberMatch(control: FormControl): any {
  const group = control.parent;
  if (!control.value) {
    return null;
  } else if (control.value !== group.controls['accountNumber'].value) {
    return { invalidBankAccountNumberMatch: true };
  }
}

// validate bank number
export function validateBankRoutingNumber(control: FormControl) {
  const REGEX = /^\d+$/;

  // empty models are valid
  if (!control.value) {
    return null;
  }

  if (control.value.match(REGEX) && control.value.length === 9) {
    const pieces = control.value.split('').map((value) => {
      return parseInt(value, 10);
    });

    const check = 3 * (pieces[0] + pieces[3] + pieces[6]) + 7 * (pieces[1] + pieces[4] + pieces[7]) + (pieces[2] + pieces[5] + pieces[8]);

    if (check % 10 === 0) {
      return null;
    } else {
      return { invalidBankRoutingNumber: true };
    }
  } else {
    return { invalidBankRoutingNumber: true };
  }
}

export function validateTermAmount(control: FormControl) {
  if (!control.value) {
    return null;
  }
  const enteredAmount = (control.value).toString().replace('$', '');
  const termAmount = enteredAmount.replace(/,/g, '');

  if (termAmount > 50000000 || termAmount <= 0) {
    return { invalidTermAmount: true };
  } else {
    return null;
  }
}

// validate signature on declarations page to proposed insured
export function validateSignatureMatch(fullName: string): ValidatorFn {
  return (control: FormControl) => {
    if (!control.value) {
      return null;
    }
    const signature = control.value.replace(/\s\s+/g, ' ').trim(); //normalize-space
    if (control.value && (fullName.trim().toLowerCase() !== signature.toLowerCase())) {
      return { invalidSignature: {message: `Please type the name exactly as it was provided in the application [${fullName}].`}  };
    }

    return null;
  };
}

const stateRules = {
  'AL': {
    'rule': '(^[0-9]{1,8}$)|(^[0-9]{7}[A-Z]{1}[0-9]{6}$)',
    'description': [
      '1-8 Numeric',
      '7 Numeric + 1 Alpha + 6 Numeric'
    ]
  },
  'AK': {
    'rule': '^[0-9]{1,7}$',
    'description': [
      '1-7 Numbers'
    ]
  },
  'AZ': {
    'rule': '(^[A-Z]{1}[0-9]{1,8}$)|(^[A-Z]{2}[0-9]{2,5}$)|(^[0-9]{9}$)',
    'description': [
      '1 Alpha + 1-8 Numeric',
      '2 Alpha + 2-5 Numeric',
      '9 Numeric'
    ]
  },
  'AR': {
    'rule': '^[0-9]{4,9}$',
    'description': [
      '4-9 Numeric'
    ]
  },
  'CA': {
    'rule': '^[A-Z]{1}[0-9]{7}$',
    'description': [
      '1 Alpha + 7 Numeric'
    ]
  },
  'CO': {
    'rule': '(^[0-9]{9}$)|(^[A-Z]{1}[0-9]{3,6}$)|(^[A-Z]{2}[0-9]{2,5}$)',
    'description': [
      '9 Numeric',
      '1 Alpha + 3-6 Numeric',
      '2 Alpha + 2-5 Numeric'
    ]
  },
  'CT': {
    'rule': '^[0-9]{9}$',
    'description': [
      '9 Numeric'
    ]
  },
  'DE': {
    'rule': '^[0-9]{1,7}$',
    'description': [
      '1-7 Numeric'
    ]
  },
  'DC': {
    'rule': '(^[0-9]{7}$)|(^[0-9]{9}$)',
    'description': [
      '7 Numeric',
      '9 Numeric'
    ]
  },
  'FL': {
    'rule': '^[A-Z]{1}[0-9]{12}$',
    'description': [
      letterTwelveNumbers
    ]
  },
  'GA': {
    'rule': '^[0-9]{7,9}$',
    'description': [
      '7-9 Numeric'
    ]
  },
  'GU': {
    'rule': '^[A-Z]{1}[0-9]{14}$',
    'description': [
      '1 Alpha + 14 Numeric'
    ]
  },
  'HI': {
    'rule': '(^[A-Z]{1}[0-9]{8}$)|(^[0-9]{9}$)',
    'description': [
      letterEightNumbers,
      '9 Numeric'
    ]
  },
  'ID': {
    'rule': '(^[A-Z]{2}[0-9]{6}[A-Z]{1}$)|(^[0-9]{9}$)',
    'description': [
      '2 Alpha + 6 Numeric + 1 Alpha',
      '9 Numeric'
    ]
  },
  'IL': {
    'rule': '^[A-Z]{1}[0-9]{11,12}$',
    'description': [
      '1 Alpha + 11-12 Numeric'
    ]
  },
  'IN': {
    'rule': '(^[A-Z]{1}[0-9]{9}$)|(^[0-9]{9,10}$)',
    'description': [
      letterNineNumbers,
      '9-10 Numeric'
    ]
  },
  'IA': {
    'rule': '^([0-9]{9}|([0-9]{3}[A-Z]{2}[0-9]{4}))$',
    'description': [
      '9 Numeric',
      '3 Numeric + 2 Alpha + 4 Numeric'
    ]
  },
  'KS': {
    'rule': '(^([A-Z]{1}[0-9]{1}){2}[A-Z]{1}$)|(^[A-Z]{1}[0-9]{8}$)|(^[0-9]{9}$)',
    'description': [
      '1 Alpha + 1 Numeric + 1 Alpha + 1 Numeric + 1 Alpha',
      letterEightNumbers,
      '9 Numeric'
    ]
  },
  'KY': {
    'rule': '(^[A-Z]{1}[0-9]{8,9}$)|(^[0-9]{9}$)',
    'description': [
      '1 Alpha + 8-9 Numeric',
      '9 Numeric'
    ]
  },
  'LA': {
    'rule': '^[0-9]{1,9}$',
    'description': [
      '1-9 Numeric'
    ]
  },
  'ME': {
    'rule': '(^[0-9]{7,8}$)|(^[0-9]{7}[A-Z]{1}$)',
    'description': [
      eightNumbers,
      '7 Numeric + 1 Alpha'
    ]
  },
  'MD': {
    'rule': '(^[A-Z]{1}[0-9]{12}$)|(^(MD)[0-9]{11}$)',
    'description': [
      letterTwelveNumbers,
      'MD + 11 Numeric'
    ]
  },
  'MA': {
    'rule': '(^[A-Z]{1}[0-9]{8}$)|(^[A-Z]{2}[0-9]{7}$)|(^[0-9]{9}$)',
    'description': [
      letterEightNumbers,
      '2 Alpha + 7 Numeric',
      '9 Numeric'
    ]
  },
  'MI': {
    'rule': '(^[A-Z]{1}[0-9]{10}$)|(^[A-Z]{1}[0-9]{12}$)',
    'description': [
      '1 Alpha + 10 Numeric',
      letterTwelveNumbers
    ]
  },
  'MN': {
    'rule': '^[A-Z]{1}[0-9]{12}$',
    'description': [
      letterTwelveNumbers
    ]
  },
  'MS': {
    'rule': '^[0-9]{9}$',
    'description': [
      '9 Numeric'
    ]
  },
  'MO': {
    'rule': '(^[A-Z]{1}[0-9]{5,9}$)|(^[A-Z]{1}[0-9]{6}[R]{1}$)|(^[0-9]{8}[A-Z]{2}$)|(^[0-9]{9}[A-Z]{1}$)|(^[0-9]{9}$)',
    'description': [
      '1 Alpha + 5-9 Numeric',
      '1 Alpha + 6 Numeric + \'R\'',
      '8 Numeric + 2 Alpha',
      '9 Numeric + 1 Alpha',
      '9 Numeric'
    ]
  },
  'MT': {
    'rule': '(^[A-Z]{1}[0-9]{8}$)|(^[0-9]{13}$)|(^[0-9]{9}$)|(^[0-9]{14}$)',
    'description': [
      letterEightNumbers,
      '13 Numeric',
      '9 Numeric',
      '14 Numeric'
    ]
  },
  'NE': {
    'rule': '^[A-Z]{1}[0-9]{3,8}$',
    'description': [
      '1 Alpha + 3-8 Numeric'
    ]
  },
  'NV': {
    'rule': '(^[0-9]{9,10}$)|(^[0-9]{12}$)|(^[X]{1}[0-9]{8}$)',
    'description': [
      '9 Numeric',
      '10 Numeric',
      '12 Numeric',
      '\'X\' + 8 Numeric'
    ]
  },
  'NH': {
    'rule': '(^[0-9]{2}[A-Z]{3}[0-9]{5}$)|(^[A-Z]{3}[0-9]{8}$)',
    'description': [
      '2 Numeric + 3 Alpha + 5 Numeric',
      '3 Alpha + 8 Numeric'
    ]
  },
  'NJ': {
    'rule': '^[A-Z]{1}[0-9]{14}$',
    'description': [
      '1 Alpha + 14 Numeric'
    ]
  },
  'NM': {
    'rule': '^[0-9]{8,9}$',
    'description': [
      '8 Numeric',
      '9 Numeric'
    ]
  },
  'NY': {
    'rule': '(^[A-Z]{1}[0-9]{7}$)|(^[A-Z]{1}[0-9]{18}$)|(^[0-9]{8}$)|(^[0-9]{9}$)|(^[0-9]{16}$)|(^[A-Z]{8}$)',
    'description': [
      '1 Alpha + 7 Numeric',
      '1 Alpha + 18 Numeric',
      '8 Numeric',
      '9 Numeric',
      '16 Numeric',
      '8 Alpha'
    ]
  },
  'NC': {
    'rule': '^[0-9]{1,12}$',
    'description': [
      '1-12 Numeric'
    ]
  },
  'ND': {
    'rule': '(^[A-Z]{3}[0-9]{6}$)|(^[0-9]{9}$)',
    'description': [
      '3 Alpha + 6 Numeric',
      '9 Numeric'
    ]
  },
  'OH': {
    'rule': '(^[A-Z]{1}[0-9]{4,8}$)|(^[A-Z]{2}[0-9]{3,7}$)|(^[0-9]{8}$)',
    'description': [
      '1 Alpha + 4-8 Numeric',
      '2 Alpha + 3-7 Numeric',
      '8 Numeric'
    ]
  },
  'OK': {
    'rule': '(^[A-Z]{1}[0-9]{9}$)|(^[0-9]{9}$)',
    'description': [
      letterNineNumbers,
      '9 Numeric'
    ]
  },
  'OR': {
    'rule': '(^[0-9]{1,9}$)|(^[A-Z]{1}[0-9]{6}$)',
    'description': [
      '1-9 Numeric',
      '1 Alpha + 6 Numeric'
    ]
  },
  'PA': {
    'rule': '^[0-9]{8}$',
    'description': [
      '8 Numeric'
    ]
  },
  'PR': {
    'rule': '(^[0-9]{9}$)|(^[0-9]{5,7}$)',
    'description': [
      '5-7 Numeric',
      '9 Numeric'
    ]
  },
  'RI': {
    'rule': '^([0-9]{7,8}$)|(^[A-Z]{1}[0-9]{6}$)',
    'description': [
      eightNumbers,
      '1 Alpha + 6 Numeric'
    ]
  },
  'SC': {
    'rule': '^[0-9]{5,11}$',
    'description': [
      '5-11 Numeric'
    ]
  },
  'SD': {
    'rule': '(^[0-9]{6,10}$)|(^[0-9]{12}$)',
    'description': [
      '6-10 Numeric',
      '12 Numeric'
    ]
  },
  'TN': {
    'rule': '^[0-9]{7,9}$',
    'description': [
      '7-9 Numeric'
    ]
  },
  'TX': {
    'rule': '^[0-9]{7,8}$',
    'description': [
      eightNumbers
    ]
  },
  'UT': {
    'rule': '^[0-9]{4,10}$',
    'description': [
      '4-10 Numeric'
    ]
  },
  'VT': {
    'rule': '(^[0-9]{8}$)|(^[0-9]{7}[A]$)',
    'description': [
      '8 Numeric',
      '7 Numeric + 1 Alpha'
    ]
  },
  'VA': {
    'rule': '(^[A-Z]{1}[0-9]{8,11}$)|(^[0-9]{9}$)',
    'description': [
      letterEightNumbers,
      letterNineNumbers,
      '1 Alpha + 10 Numeric',
      '1 Alpha + 11 Numeric',
      '9 Numeric'
    ]
  },
  'WA': {
    'rule': '(^(?=.{12}$)[A-Z]{1,7}[A-Z0-9\\*]{4,11}$)|(^[A-Z0-9]{7}$)',
    'description': [
      '1-7 Alpha + any combination of Alpha, Numeric, and * for a total of 12 characters',
      '7 Alphanumeric'
    ]
  },
  'WV': {
    'rule': '(^[0-9]{7}$)|(^[A-Z]{1,2}[0-9]{5,6}$)',
    'description': [
      '7 Numeric',
      '1-2 Alpha + 5-6 Numeric'
    ]
  },
  'WI': {
    'rule': '^[A-Z]{1}[0-9]{13}$',
    'description': [
      '1 Alpha + 13 Numeric'
    ]
  },
  'WY': {
    'rule': '^[0-9]{9,10}$',
    'description': [
      '9-10 Numeric'
    ]
  }
};

// validate drivers license
export function validateDriverLicense(control: FormControl) {
  // parent group
  const group = control.parent;

  // empty models are valid
  if (!control.value || !group.controls['DriversLicenseState'].value) {
    return null;
  }

  const value = control.value;
  const rule = stateRules[group.controls['DriversLicenseState'].value].rule;
  const regex = new RegExp(rule, 'i');
  const valNoSpaces = value.replace(/ /g, '');

  return (regex.test(valNoSpaces) && !value.match(/\s/)) ? null : {
    invalidDl: true
  };

}

export const validateSupplementalFaceAmount: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  if (!control.value) { return null; }

  const group = control.parent;

  const FlexibleAmount = group.get('FlexiblePremiumProductsBaseAmount').value;
  const SupplementAmount = control.value;

  const FAmount = FlexibleAmount.replace(/[^\w\s]/gi, '');
  const SAmount = SupplementAmount.replace(/[^\w\s]/gi, '');

  // tslint:disable-next-line:radix
  return (parseInt(SAmount) > parseInt(FAmount)) ? { invalidSupplementAmount: true } : null;
  return null;
};

export function validateFlexiblePremiumIncreaseBy(control: FormControl) {
  if (!control.value) {
    return null;
  }

  const REGEX = /^(2[0-5]|[01]?[0-9])$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidIncreaseByPercentage: true };
  }
}

export function validateSupplementYears(control: FormControl) {
  if (!control.value) {
    return null;
  }

  const REGEX = /^(12[0-5]|1[01][1-9]|[0-9]?[0-9])$/;

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidNumber: true };
  }
}

export function validateAutoTransfer(control: FormControl) {
  if (!control.value) { return null; }
  const enteredAmount = control.value;
  const dollarAmount = enteredAmount.replace(/[^\w\s]/gi, '');

  const REGEX = /^0*(?:[2-9]|[1-9]\d\d*)$/;
  //
  if (dollarAmount.match(REGEX) || dollarAmount == '') {
    return null;
  } else {
    return { invalidNumber: true };
  }
}

export function validateAutoTransferAmt(control: FormControl) {
  if (!control.value) { return null; }
  const enteredAmount = control.value;
  const dollarAmount = enteredAmount.replace(/[^\w\s]/gi, '');

  const REGEX = /^0*(?:[0-9]|[1-9]\d\d*)$/;
  //
  if (dollarAmount.match(REGEX) || dollarAmount == '') {
    return null;
  } else {
    return { invalidNumber: true };
  }
}

/**
 * Source: http://regexlib.com/UserPatterns.aspx?authorId=ea23ae18-1a81-41f9-a637-1ea655cc1fe0&AspxAutoDetectCookieSupport=1
 * verfied at: https://regex101.com/
 * @param control
 */
export function validateUSBankRoutingNumber(control: FormControl) {
  if (!control.value) {
    return null;
  }

  const REGEX = /^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2])|80)([0-9]{7})$/;

  if (!(control.value).match(REGEX)) {
    return { invalidBankRoutingNumber: true };
  }

  return null;
}

// Require at least one agent to be the "Servicing Agent"
export function validateServicingAgent1(control: FormControl) {
  if(!control){
    return null;
  }
  
  let totalYeses = 0;
  let totalNos = 0;
  let yesSelected = false;

  const AgentReportAgentInformation = control.root.get('AgentReportAgentInformation') as FormArray;
  if (AgentReportAgentInformation) {
    if (AgentReportAgentInformation.length > 0) {
      AgentReportAgentInformation.controls.forEach((group: any) => {
        const selectedIndex = AgentReportAgentInformation.controls.indexOf(group);
        const yesOrNo = group.get('AgentReportAgentInformationServAgt').value;

        group.get('AgentReportAgentInformationServAgt').clearValidators();
        group.get('AgentReportAgentInformationServAgt').setValidators([Validators.required]);
        group.get('AgentReportAgentInformationServAgt').updateValueAndValidity({ emitEvent: false });

        if (yesOrNo === 'true') {
          totalYeses++;
          yesSelected = true;
        } else if (yesOrNo === 'false') {
          totalNos++;
        }
      });
    }
    if (totalYeses > 1) {
      return { servicingAgentMaxLimit: true };
    }

    if (yesSelected === false) {
      return { servicingAgentMinRequired: true };
    }
    return null;
  }
}

export function validateServicingAgent(mode: any): ValidatorFn {
  return (control: FormControl) => {
    if (mode === 'minRequired') {
      return { servicingAgentMinRequired: true };
    } else if (mode === 'maxLimit') {
      return { servicingAgentMaxLimit: true };
    }
    return null;
  };
}



// Require at least one agent to be the "Servicing Agent"
export function validateDeadEnd(control: FormControl) {
  if (control.value === 'true') {
    return { deadEnd: true };
  }
  return null;
}

export function validateCurrency(control: FormControl) {
  if (control.value === '$') {
    return { required: true };
  }
  return null;
}

export function validateExistingPolicy(ReplaceExistingInsuranceOrUseFunds: any): ValidatorFn {
  return (control: FormControl) => {

    if (ReplaceExistingInsuranceOrUseFunds == null) {
      return null;
    }

    if (!control.value) { return null; }

    const ExistingPolicyToBeReplaced = control.value;


    if (ReplaceExistingInsuranceOrUseFunds === 'false' && ExistingPolicyToBeReplaced === 'true') {
      return { invalidExistingPolicy: true };
    }
    return null;
  };
}

export function validateBillingMethod(BillingMethod: any): ValidatorFn {
  return (control: FormControl) => {

    if (BillingMethod == null) {
      return null;
    }

    if (!control.value) { return null; }

    if (BillingMethod === 'DirectBill' && control.value === 'true') {
      return { wrongBillingMethod: true };
    }
    return null;
  };
}

export function validateExistingInsuranceAnnuities(control: FormControl) {
  const group = control.parent;

  if (!control.value) {
    return null;
  }

  if (control.value === 'true') {
    const ExistingLifeInsurance = group.controls['ExistingLifeInsurance'].value;

    if (ExistingLifeInsurance === 'false') {
      return { InvalidExistingInsuranceAnnuities: true };
    }

    return null;
  }
}

export function validateMaxAge(control: FormControl) {
  if (!control.value) {
    return null;
  }

  const REGEX = /^([1-9]|[1-8][0-9]|9[0-9]|1[0-2][0-9]|130)$/;

  if (!(control.value).match(REGEX)) {
    return { invalidMaxAge: true };
  }

  return null;
}

export function validateMaxIllustrationYears(control: FormControl) {
  if (!control.value) {
    return null;
  }

  const REGEX = /^([1-9]|[1-8][0-9]|9[0-9]|100)$/;

  if (!(control.value).match(REGEX)) {
    return { invalidYears: true };
  }

  return null;
}


export function validateBenefitMaxAmount(control: FormControl) {
  if (!control.value) {
    return null;
  }

  const REGEX = /([1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-8][0-9]{4}|9[0-8][0-9]{3}|99[0-8][0-9]{2}|999[0-8][0-9]|9999[0-9]|[1-8][0-9]{5}|9[0-8][0-9]{4}|99[0-8][0-9]{3}|999[0-8][0-9]{2}|9999[0-8][0-9]|99999[0-9]|[1-8][0-9]{6}|9[0-8][0-9]{5}|99[0-8][0-9]{4}|999[0-8][0-9]{3}|9999[0-8][0-9]{2}|99999[0-8][0-9]|999999[0-9]|[1-8][0-9]{7}|9[0-8][0-9]{6}|99[0-8][0-9]{5}|999[0-8][0-9]{4}|9999[0-8][0-9]{3}|99999[0-8][0-9]{2}|999999[0-8][0-9]|9999999[0-9]|[1-8][0-9]{8}|9[0-8][0-9]{7}|99[0-8][0-9]{6}|999[0-8][0-9]{5}|9999[0-8][0-9]{4}|99999[0-8][0-9]{3}|999999[0-8][0-9]{2}|9999999[0-8][0-9]|99999999[0-9]|[1-8][0-9]{9}|9[0-8][0-9]{8}|99[0-8][0-9]{7}|999[0-8][0-9]{6}|9999[0-8][0-9]{5}|99999[0-8][0-9]{4}|999999[0-8][0-9]{3}|9999999[0-8][0-9]{2}|99999999[0-8][0-9]|999999999[0-9])/;

  if (!(control.value).match(REGEX)) {
    return { invalidNumber: true };
  }

  return null;
}

export function validateThreeDigitNumber(control: FormControl) {
  if (control.value) {
    const REGEX = /^\d{1,3}$/;

    if (!(control.value).match(REGEX) || isNaN(Number(control.value))) {
      return { invalidThreeDigit: true };
    }
  }
  return null;

}

export function validateInt32(control: FormControl) {

  if (!control.value) {
    return null;
  }

  const numVal = Number(control.value.toString().replace(/[$,]/g, ''));

  if ((Number.isInteger(numVal)) && numVal > -2147483648 && numVal < 2147483647) {
    return null
  } else {
    return { InvalidNumber: true };
  }
}

export function validateInt32Required(control: FormControl) {

  if (!control.value) {
    return null;
  }

  const numVal = Number(control.value.replace(/[$,]/g, ''));

  if ((Number.isInteger(numVal)) && numVal > 0 && numVal < 2147483647) {
    return null
  } else {
    return { InvalidNumber: true };
  }
}

export function validateRiderName(control: FormControl) {
  if (!control.value) { return null; }

  const REGEX = /^(?![\d\s\.\-\'\"]+$)[a-z\s1. \-\.\'\"]+$/i;

  if ((control.value).length > 50) {
    return { invalidName: true };
  }

  if (!control.value || control.value.match(REGEX)) {
    return null;
  } else {
    return { invalidName: true };
  }
}

export function validateFreeform(control: FormControl) {
  if (!control.value) { return null; }

  const REGEX = /^(?![\s])[a-zA-Z0-9\s,-:@!$%^&*()?><'#;\/"_+]+$/;

  if (!(control.value).match(REGEX)) {
    return { invalidName: true };
  }

  return null;
}

export function validateFreeformVelogica(control: FormControl) {
  if (!control.value) { return null; }

  const REGEX = /^[\w\s\-\']+$/g;

  if (!(control.value).match(REGEX)) {
    return { invalidName: true };
  }

  return null;
}

// validation for custom mat-table percent totals on IUL section
export function validateHundredTotal(control: FormControl) {

  const val = control.value ? +control.value.replace(/[\D]/gm, '') : null;

  if (val && val !== 100) {
    return { notOneHundred: true };
  }

  return null;
}

export function validate4digitPastYear(control: FormControl) {
  if (!control.value) { return null; }

  const REGEX = /^(19|20)\d{2}$/;

  if (!(control.value).match(REGEX)) {
    return { InvalidPastCurrentYear: true };
  }

  const currentYear = (new Date()).getFullYear();

  // tslint:disable-next-line:radix
  if (parseInt(control.value) > currentYear) {
    return { InvalidPastCurrentYear: true };
  }

  return null;
}
export function validatePastDate(control: FormControl) {
 
  isvalidatePastDate=true;
  
  if (!control.value) {
    return null;
  }

  // check length
  if (control.value && control.value.length !== 10) {
    return { invalidDate: true };
  }
  const date = luxon.DateTime.fromFormat(control.value, monthYearFormat);
  const validDate = luxon.DateTime.fromFormat(beginDate, yearMonthFormat);
  const isPast = isBefore(date);
  const isValid = isBefore(date, validDate);

  if (isPast) {
    return { invalidDate: true };
  } else {
    return null;
  }
}
